/**
 * 教师端认证接口（education-teacher）
 * Swagger: /teacher/v2/api-docs
 * basePath /teacher + path /teacher/auth/* => /teacher/teacher/auth/*
 *
 * 说明：
 * - 登录 / 用户信息 / 退出：走本文件接口
 * - 菜单：教师端不使用 auth/routers，统一用静态菜单 teacherStaticMenus
 */
import { get, post, del } from "../request";

const AUTH_PREFIX = "/teacher/teacher/auth";

/**
 * 教师登录
 * POST /teacher/teacher/auth/login
 * Body: { account, password }
 */
export function teacherAuthLogin(data) {
  return post(`${AUTH_PREFIX}/login`, data, {
    // 登录失败（含后端未放行）时不要当成「登录过期」清会话
    skipAuthRedirect: true
  });
}

/**
 * 获取当前登录教师信息、角色和权限
 * GET /teacher/teacher/auth/info
 */
export function teacherAuthInfo() {
  return get(`${AUTH_PREFIX}/info`);
}

/**
 * 教师退出
 * DELETE /teacher/teacher/auth/logout
 */
export function teacherAuthLogout() {
  return del(`${AUTH_PREFIX}/logout`, {
    skipAuthRedirect: true
  });
}

export default {
  teacherAuthLogin,
  teacherAuthInfo,
  teacherAuthLogout
};



// WEBPACK FOOTER //
// ./src/api/teacher/auth.js